import styled from "styled-components"

export const StyledNutrientInformation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const StyledLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.14px;
`

export const StyledInfoBox = styled.div`
  border-radius: 8px;
  border: 0.5px solid var(--Schemes-Outline-Variant, rgba(0, 38, 58, 0.32));
  background: #fff;
  box-shadow: 0px 1px 6px 0px rgba(28, 31, 33, 0.06);

  display: flex;
  flex-direction: column;

  @supports (-webkit-touch-callout: none) {
    border: 0.8px solid var(--Schemes-Outline, rgba(0, 38, 58, 0.32));
  }
`

export const StyledNutrientInfoHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 12px;
  padding-right: 0px;
  border-bottom: 1px solid rgba(5, 5, 12, 0.1);
`

export const EditNutrientLabel = styled.div`
  color: var(--Schemes-Brand-color-Primary, #0da3ba);
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  padding: 8px 12px;
  cursor: pointer;
`

export const NutrientChartWrapper = styled.div`
  width: 84px;
  height: 60px;
  position: relative;
  flex-shrink: 0;
  padding: 0 12px;
`

export const NutrientChartCalorieBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const NutrientChartCalorie = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 160%;
`
export const NutrientChartCalorieLabel = styled.div`
  color: #8c8c8c;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px; /* 100% */
  letter-spacing: 0.109px;
`

export const NutrientDetailsBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
`

export const NutrientDetailsItemLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #69757d;
  line-height: 120%;
`

export const NutrientDetailsItemValue = styled.div`
  font-size: 16px;
  font-style: normal;
  line-height: 120%;
  color: #1c1f21;
`

export const NutrientDetailsItemPercent = styled.div<{ $color: string }>`
  font-size: 14px;
  line-height: 120%;
  color: ${({ $color }) => $color};
`
